import {isValid,differenceInCalendarYears, differenceInCalendarMonths, differenceInCalendarDays, 
    addYears, getYear, getMonth, getDay, compareDesc, addDays} from 'date-fns';


export const toDate = (date: Date) : Date => new Date(getYear(date), getMonth(date), getDay(date));


export const diffInYears = (startDate: Date, endDate: Date) : number => {

    const start = toDate(startDate);
    const end = toDate(endDate);

    if(compareDesc(startDate,endDate) < 0)
        return 0;

    let y: number = 0;
    while( compareDesc( addDays( addYears(startDate,y), -1) , endDate) > 0)
        y++;   

    return y;
}


export const exportToExcel = (data: any, fileName: string) : void => {

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    // const ws = XLSX.utils.json_to_sheet(data);
    // const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    // const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    
    // const blobData = new Blob([excelBuffer], { type: fileType });
    // FileSaver.saveAs(blobData, fileName + fileExtension);
}